import {useUserStore} from '../stores/user'
import {useIdpAuth } from './useIdpAuth'

export function useAuth() {
  const userStore = useUserStore()
  const {redirectToIdp} = useIdpAuth()

  const logout = async () => {
    userStore.clearUser()
    redirectToIdp('logout', window.location.origin)
  }

  return {
    logout
  }
}
